import React from 'react';
import { useGetPublicSetStatsQuery } from 'store/services/sets/publicSetsApi';
import './SetStatsStrip.css';

interface SetStatsStripProps {
  setCode: string;
}

export const SetStatsStrip: React.FC<SetStatsStripProps> = ({ setCode }) => {
  const { data, isLoading, isError } = useGetPublicSetStatsQuery(setCode, { skip: !setCode });

  if (isLoading || isError || !data) return null;

  const { cardsListed, cardsWanted, activeUsersCount } = data;
  if (cardsListed === 0 && cardsWanted === 0 && activeUsersCount === 0) return null;

  return (
    <div className="set-stats-strip" aria-label="TradeMagic activity">
      {cardsListed > 0 && (
        <span className="set-stats-chip">
          <span className="set-stats-chip-count">{cardsListed.toLocaleString()}</span>
          <span className="set-stats-chip-label">listed for trade</span>
        </span>
      )}
      {cardsWanted > 0 && (
        <span className="set-stats-chip">
          <span className="set-stats-chip-count">{cardsWanted.toLocaleString()}</span>
          <span className="set-stats-chip-label">wanted</span>
        </span>
      )}
      {activeUsersCount > 0 && (
        <span className="set-stats-chip">
          <span className="set-stats-chip-count">{activeUsersCount.toLocaleString()}</span>
          <span className="set-stats-chip-label">
            {activeUsersCount === 1 ? 'active trader' : 'active traders'}
          </span>
        </span>
      )}
    </div>
  );
};
